<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-flex md12>
            <material-card
                color="green"
                title="Billing Summary"
                class="grid-card"
            >
                <vue-good-table
                    class="pt-0"
                    style="cursor: pointer;"
                    ref="table"
                    :columns="columns"
                    :rows="billingSummary"
                    :search-options="{
                        enabled: false,
                    }"
                >
                    <div
                        slot="table-actions"
                        style="display: flex; flex-flow: row;"
                        class="action_buttons"
                    >
                        <v-select
                            style="width: 200px; padding-top: 20px !important;"
                            class="mr-2 pb-2 pt-0 mt-0"
                            label="Term"
                            @change="loadData"
                            :items="terms.map((t) => t.term)"
                            v-model="regID"
                            hide-details
                        ></v-select>
                        <v-spacer></v-spacer>
                        <download-excel
                            :fields="exportFields()"
                            :name="getExportFileName()"
                            :before-generate="() => (isExporting = true)"
                            :before-finish="() => (isExporting = false)"
                            :fetch="exportToExcel"
                            type="xls"
                        >
                            <v-btn
                                small
                                icon
                                :loading="isExporting"
                                class="mt-4 mb-0"
                                ><v-icon color="success"
                                    >mdi-file-export</v-icon
                                ></v-btn
                            >
                        </download-excel>
                    </div>
                    <template slot="table-header-row" slot-scope="props">
                        <div>
                            <span>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                        </div>
                    </template>
                    <template slot="table-row" slot-scope="props">
                        <div class="font-weight-regular">
                            <span>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                        </div>
                    </template>
                </vue-good-table>
            </material-card>
        </v-flex>
    </v-container>
</template>

<script>
import { pluralize, sum, formatCurrency } from "../../utils/helpers.js";
import moment from "moment";

export default {
    data: () => ({
        billingSummary: [],
        regID: "",
        terms: [],
        isExporting: false,

        columns: [
            {
                sortable: false,
                label: "Type",
                field: "type",
                hidden: false,
            },
            {
                sortable: false,
                label: "Description",
                field: "description",
                hidden: false,
            },
            {
                sortable: false,
                label: "Amount",
                field: "amount",
                type: "Number",
                formatFn: (value) => {
                    return formatCurrency(value);
                },
                tdClass: (row) => {
                    return row.type == "Charge" ||
                        row.description.trim() == "Void"
                        ? "text-success"
                        : "text-danger";
                },
                hidden: false,
            },
        ],
    }),
    watch: {},
    async created() {
        await this.loadRegID();

        this.loadTerms();
        this.loadData();
    },
    methods: {
        async loadRegID() {
            this.regID = await this.$http.get("api/yk/getRegID");
        },
        async loadTerms() {
            this.terms = await this.$http.get("api/yk/getRegTerms");
        },
        async loadData() {
            const response = await this.$http.get(
                "api/yk/GetBillingSummary?regID=" + this.regID,
            );

            this.billingSummary = response;
        },
        getExportFileName() {
            return "YKC Billing Summary - " + moment().format("L");
        },
        exportFields() {
            let fields = {};

            this.columns.forEach((column) => {
                if (column.hidden) return;

                fields[column.label] = column.field;
            });

            return fields;
        },
        async exportToExcel() {
            return this.billingSummary;
        },
    },
};
</script>
<style>
.toggle-button {
    font-size: 15px;
    padding: 5px !important;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active {
    background-color: #dcdfe6;
}
.v-btn__content {
    color: unset;
}
</style>
